
import { envConfig } from "@env/env-config";

/**
 * @description 实名用户 Rest配置
 * @deprecated
 * Swagger所属分类:
 */
export const AuthorizationRestConfig: Array<qpmn.common.rest.IServiceConfig> = [
    {
        service: "authorizationUserRestService",
        funcName: "login",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "partner/token",
            isAuth: false
        }
    },
    {
        service: "authorizationUserRestService",
        funcName: "regist",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "partner/registration"
        }
    }
]